import DesLibraryComponentRevisionsViewModel from 'viewmodel/DesLibraryComponentRevisionsViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';


export default class DesLibraryComponentRevisions extends DesBaseCatalogAcc {
    constructor() {
        super(DesLibraryComponentRevisionsViewModel);
    }

    get libraryComponentId() {
        return this.getAttribute(DesAccConstants.LIBRARY_COMPONENTID) || "";
    }

    get libraryUrn() {
        return this.getAttribute(DesAccConstants.LIBRARY_URN);
    }

    getProps() {
        return {
            librarycomponentid: this.libraryComponentId,
            libraryurn: this.libraryUrn
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', DesAccConstants.LIBRARY_COMPONENTID,
        DesAccConstants.LIBRARY_URN];
    }
}

if (!window.customElements.get('des-library-component-revisions')) {
    window.customElements.define('des-library-component-revisions', DesLibraryComponentRevisions);
}
